"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/**
 * Singleton observer class that tracks window dimensions and notifies subscribers
 * when the window is resized. Uses ResizeObserver for efficient dimension tracking.
 */
var WindowDimensionsObserver = /*#__PURE__*/function () {
  /**
   * Creates a WindowDimensionsObserver instance. Returns existing instance if one exists.
   * Automatically starts observing window resize events.
   */
  function WindowDimensionsObserver() {
    var _this = this;
    (0, _classCallCheck2["default"])(this, WindowDimensionsObserver);
    if (WindowDimensionsObserver.instance) {
      return WindowDimensionsObserver.instance;
    }
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.listeners = new Set();
    this.observer = new ResizeObserver(function () {
      _this.width = window.innerWidth;
      _this.height = window.innerHeight;
      _this.notifyListeners();
    });
    this.observer.observe(document.documentElement);
    WindowDimensionsObserver.instance = this;
  }

  /**
   * Subscribes to window dimension changes.
   *
   * @param {Function} callback - Function called when dimensions change.
   *   Receives (width: number, height: number) as arguments.
   * @returns {Function} Unsubscribe function to remove the callback
   *
   * @example
   * ```javascript
   * const unsubscribe = windowDimensionsObserver.subscribe((width, height) => {
   *   console.log(`Window resized to: ${width}x${height}`);
   * });
   *
   * // Later, to unsubscribe:
   * unsubscribe();
   * ```
   */
  return (0, _createClass2["default"])(WindowDimensionsObserver, [{
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;
      this.listeners.add(callback);
      // Immediately invoke with current state
      callback(this.width, this.height);

      // Return unsubscribe function
      return function () {
        _this2.listeners["delete"](callback);
      };
    }

    /**
     * Notifies all registered listeners of current window dimensions.
     * Called automatically when window is resized.
     *
     * @private
     */
  }, {
    key: "notifyListeners",
    value: function notifyListeners() {
      var _this3 = this;
      this.listeners.forEach(function (callback) {
        callback(_this3.width, _this3.height);
      });
    }
  }]);
}();
/**
 * Singleton instance of WindowDimensionsObserver for tracking window dimensions.
 *
 * @type {WindowDimensionsObserver}
 * @example
 * ```javascript
 * import windowDimensionsObserver from './windowDimensionsObserver';
 *
 * // Get current dimensions
 * const currentWidth = windowDimensionsObserver.width;
 * const currentHeight = windowDimensionsObserver.height;
 *
 * // Subscribe to changes
 * const unsubscribe = windowDimensionsObserver.subscribe((width, height) => {
 *   console.log('Window resized:', { width, height });
 * });
 * ```
 */
var windowDimensionsObserver = new WindowDimensionsObserver();
var _default = exports["default"] = windowDimensionsObserver;